"use strict";

module.exports = function() {
	return function() {};
};



//////////////////
// WEBPACK FOOTER
// ./scripts/noop.js
// module id = 8
// module chunks = 0